import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { fmtDate } from "@/lib/format";
import { PageHeader, EmptyState } from "@/components/common";
import { Button } from "@/components/ui/button";
import { Card } from "@/components/ui/card";
import { Bell, Check, X, CheckCheck } from "lucide-react";

const DOT = { overdue: "bg-rose-500", payment: "bg-emerald-500", invoice: "bg-blue-500", success: "bg-emerald-500", info: "bg-blue-500", warning: "bg-amber-500" };

export default function NotificationsPage() {
  const [items, setItems] = useState([]);
  const load = () => api.get("/notifications").then(setItems).catch(() => {});
  useEffect(() => { load(); }, []);
  const read = async (id) => { await api.post(`/notifications/${id}/read`, {}); load(); };
  const dismiss = async (id) => { await api.del(`/notifications/${id}`); load(); };
  const readAll = async () => { await api.post("/notifications/read-all", {}); load(); };

  return (
    <div>
      <PageHeader title="Notifications" subtitle={`${items.filter((i) => i.status === "unread").length} unread`} testid="notifications-header">
        <Button variant="outline" onClick={readAll}><CheckCheck className="w-4 h-4 mr-1" /> Mark all read</Button>
      </PageHeader>
      {items.length === 0 ? <EmptyState icon={Bell} title="No notifications" hint="You're all caught up." /> : (
        <div className="space-y-2">
          {items.map((n) => (
            <Card key={n.id} className={`border-slate-200 shadow-sm p-4 flex items-start gap-3 ${n.status === "unread" ? "bg-indigo-50/40" : ""}`}>
              <span className={`w-2.5 h-2.5 rounded-full mt-1.5 shrink-0 ${DOT[n.severity] || DOT[n.type] || "bg-slate-400"}`} />
              <div className="flex-1 min-w-0">
                <p className="text-sm font-medium text-slate-800">{n.title}</p>
                <p className="text-sm text-slate-500">{n.message}</p>
                <p className="text-xs text-slate-400 mt-0.5">{fmtDate(n.at)}</p>
              </div>
              <div className="flex gap-1">
                {n.status === "unread" && <Button size="sm" variant="ghost" onClick={() => read(n.id)}><Check className="w-4 h-4" /></Button>}
                <Button size="sm" variant="ghost" className="text-slate-400" onClick={() => dismiss(n.id)}><X className="w-4 h-4" /></Button>
              </div>
            </Card>
          ))}
        </div>
      )}
    </div>
  );
}
